import { matchPath } from "react-router";
import { AJUDA_DAS_PAGINAS } from "./paginas";
import type { AjudaDaPagina, ChaveDePagina } from "./tipos";

// Ordem importa: a primeira que casa vence (a ficha em outra clínica antes da ficha comum).
const ROTAS: Array<{ padrao: string; chave: ChaveDePagina | ((p: Record<string, string | undefined>) => ChaveDePagina | null) }> = [
  { padrao: "/inicio", chave: "inicio" },
  { padrao: "/agenda", chave: "agenda" },
  { padrao: "/pacientes", chave: "pacientes" },
  { padrao: "/pacientes/em/:organizacaoId/:id", chave: "ficha-em-outra-clinica" },
  { padrao: "/pacientes/:id", chave: "ficha-do-paciente" },
  { padrao: "/protese", chave: "protese" },
  { padrao: "/procedimentos", chave: "procedimentos" },
  { padrao: "/arquivos", chave: "arquivos" },
  { padrao: "/lab/arquivos", chave: "arquivos" },
  { padrao: "/lab/cadastros", chave: "lab-cadastros" },
  { padrao: "/lab/catalogo", chave: "lab-catalogo" },
  { padrao: "/lab/catalogo/gerenciar", chave: "lab-catalogo-gerenciar" },
  { padrao: "/lab/catalogo/visualizar", chave: "lab-catalogo-visualizar" },
  { padrao: "/lab/comecar", chave: "lab-comecar" },
  { padrao: "/lab/estoque", chave: "lab-estoque" },
  { padrao: "/lab/producao", chave: "lab-producao" },
  { padrao: "/lab/pedidos", chave: "lab-pedidos" },
  { padrao: "/financeiro", chave: "financeiro" },
  { padrao: "/equipe", chave: "equipe" },
  { padrao: "/clinica", chave: "minha-clinica" },
  { padrao: "/organizacoes", chave: "organizacoes" },
  { padrao: "/apps-pro", chave: "apps-pro" },
  { padrao: "/menu", chave: "menu" },
  { padrao: "/notificacoes", chave: "notificacoes" },
  { padrao: "/configuracoes", chave: "configuracoes" },
  { padrao: "/configuracoes/:secao", chave: (p) => (`configuracoes:${p.secao}` in AJUDA_DAS_PAGINAS ? (`configuracoes:${p.secao}` as ChaveDePagina) : "configuracoes") },
  { padrao: "/conta", chave: "conta" },
  { padrao: "/conta/:secao", chave: (p) => (`conta:${p.secao}` in AJUDA_DAS_PAGINAS ? (`conta:${p.secao}` as ChaveDePagina) : "conta") },
];

/** Ajuda da rota atual, ou null (placeholders, legado, rota sem texto). */
export function ajudaDaRota(pathname: string): AjudaDaPagina | null {
  for (const r of ROTAS) {
    const m = matchPath({ path: r.padrao, end: true }, pathname);
    if (!m) continue;
    const chave = typeof r.chave === "function" ? r.chave(m.params) : r.chave;
    return chave ? AJUDA_DAS_PAGINAS[chave] : null;
  }
  return null;
}
